import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createFolderLoading: false,
  getFolderLoading: false,
  getFileLoading: false,
  renameFileLoading: false,
  uploadFileLoading: false,
  updateFileLoading: false,
  folders: [],
  files: null,
  uploadDocModal: false,
  selectedDocModal: null,
  expiredFiles:[]
};

export const documentSlice = createSlice({
  name: "document",
  initialState,
  reducers: {
    setFolderLoading(state, action) {
      return {
        ...state,
        getFolderLoading: action?.payload,
      };
    },
    setCreateFolderLoading(state, action) {
      return {
        ...state,
        createFolderLoading: action?.payload,
      };
    },
    setRenameFileLoading(state, action) {
      return {
        ...state,
        renameFileLoading: action?.payload,
      };
    },
    setFileLoading(state, action) {
      return {
        ...state,
        getFileLoading: action?.payload,
      };
    },
    setUploadFileLoading(state, action) {
      return {
        ...state,
        uploadFileLoading: action?.payload,
      };
    },

    setUpdateFileLoading(state, action) {
      return {
        ...state,
        updateFileLoading: action?.payload,
      };
    },

    setFolders(state, action) {
      return {
        ...state,
        getFolderLoading: false,
        folders: action.payload,
      };
    },
    setFiles(state, action) {
      return {
        ...state,
        getFileLoading: false,
        files: action.payload,
      };
    },

      setExpiredFiles(state, action) {
      return {
        ...state,
        getFileLoading: false,
        expiredFiles: action.payload,
      };
    },
    setUploadDocModal(state, action) {
      return {
        ...state,
        uploadDocModal: action.payload,
      };
    },
    setSelectedDocModal(state, action) {
      return {
        ...state,
        selectedDocModal: action.payload,
      };
    },
  },
});

export const {
  setFolderLoading,
  setCreateFolderLoading,
  setFileLoading,
  setUploadFileLoading,
  setUpdateFileLoading,
  setFolders,
  setFiles,
  setRenameFileLoading,
  setUploadDocModal,
  setSelectedDocModal,
  setExpiredFiles,
} = documentSlice.actions;
export default documentSlice.reducer;
